import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() { }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  set(key:string, data:any){
    try {
      localStorage.setItem(key, JSON.stringify(data));
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
    }
  }

  get(key:string){
    try {
      return JSON.parse(localStorage.getItem(key));      
    } catch(e) {
      // eslint-disable-next-line no-console
      console.log(e);
    }
  }

}
